import { render, staticRenderFns } from "./BiOtherPoliciesBanner.vue?vue&type=template&id=350f7950&"
import script from "./BiOtherPoliciesBanner.vue?vue&type=script&lang=ts&"
export * from "./BiOtherPoliciesBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports